import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getNewsSubscriptionsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/news/categories");

  return response.data;
};
